<ng-container *ngIf="control">
    <fui-mandatory-validation *ngIf="forceRequired || (required | async)"
                              [control]="control"></fui-mandatory-validation>
    <fui-error-validation [control]="control" [focussed]="focussed"
                          [verticalAlignment]="errorVerticalAlignment"></fui-error-validation>
    <fui-success-validation [control]="control"></fui-success-validation>
</ng-container>
